import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import React from "react";
import {
  Button,
  Linking,
  Platform,
  SafeAreaView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { AppProvider } from "./components/common/context-provider/ContextProvider";
import Confirmation from "./components/pages/ConfirmationPage";
import DefaultPage from "./components/pages/DefaultPage";
import Registration from "./components/pages/RegisterationPage";
import WebLandingPage from "./components/pages/WebPage";

const Stack = createStackNavigator();

export default function App() {
  const navigateToRegisteration = ({ navigation }) => (
    <DefaultPage navigation={navigation} nextPage={"Registration"} />
  );

  const navigateToConfirmation = ({ navigation }) => (
    <Registration navigation={navigation} nextPage={"Confirmation"} />
  );

  const navigateToHome = ({ navigation }) => (
    <Confirmation navigation={navigation} firstPage={"Home"} />
  );

  return (
    <NavigationContainer>
      <SafeAreaView style={styles.container}>
        <AppProvider>
          {Platform.OS === "web" ? (
            <WebLandingPage />
          ) : (
            <Stack.Navigator
              initialRouteName="Home"
              screenOptions={{
                headerStyle: { backgroundColor: "#000" },
                headerTintColor: "#fff",
                headerTitleStyle: { fontWeight: "bold" },
              }}
            >
              <Stack.Screen
                name="Home"
                children={navigateToRegisteration}
                options={{ title: "Huxedo" }}
              />
              <Stack.Screen
                name="Registration"
                children={navigateToConfirmation}
                options={{ title: "Register" }}
              />
              <Stack.Screen
                name="Confirmation"
                children={navigateToHome}
                options={{ title: "Confirmation" }}
              />
            </Stack.Navigator>
          )}
        </AppProvider>
      </SafeAreaView>
    </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#000",
  },
  webContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});
